import * as types from './actionTypes';  
import newBrokerDelaerConnectionApi from '../api/newBrokerDealerConnectionApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';

export function newBrokerDelaerConnection(data) {

  return {
    type: types.DO_NEW_BROKER_DEALER_CONNECTION, 
    data
  };
}

export function newBrokerDealerConnectionRes(data) {  
  return {
    type: types.DO_NEW_BROKER_DEALER_CONNECTION_RES, 
    data
  };
}

export function new_broker_dealer_connection(data) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      newBrokerDelaerConnectionApi.newBrokerDelaerConnection(data).then(res => {
        dispatch(newBrokerDealerConnectionRes(res));
        if(res.error){
          Swal.fire({
            title: res.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          })
        }
      }).catch(error => {
        return error
      });
    };
  }else{
    logout()
  }
}
